// src/components/OrderEntry/components/Badge6Actions.jsx
// ============================================================================
// BLOCK B6.00 — Badge 6 Actions (JSX)
// ----------------------------------------------------------------------------
// Intent: Render Badge-6 controls (Input Sugar Note / Revision Requested / Submit)
//         with ZERO business logic.
// Notes:
// - Badge 6 is the ONLY location for these actions.
// - "Input Sugar Note" applies to ALL picking sheets below (Excel parity).
// ============================================================================

import React from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';

export default function Badge6Actions({
  hasSheets,
  disabled,
  revReqLocked,

  // NEW: show-only credit hold checkbox (Excel parity)
  showCreditHold,
  creditHoldChecked,

  revReq,
  onToggleRevReq,
  showInputSugarNote,
  onInputSugarNote,
  showSubmit,
  onSubmit,
  sugarButtonRef,
}) {
  // ============================================================================
  // BLOCK BADGE6.BUTTONS.STYLE.0 — Primary action button style
  // ============================================================================
  const badgePrimaryButtonSx = {
    backgroundColor: '#1976d2', // MUI primary blue
    color: '#fff',
    textTransform: 'none',
    fontWeight: 600,

    '&:hover': {
      backgroundColor: '#1565c0',
    },

    '&.Mui-disabled': {
      backgroundColor: 'rgba(25, 118, 210, 0.3)',
      color: '#fff',
    },
  };

  return (
    <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
      {showInputSugarNote && (
        <Box>
          <Button
            size="small"
            variant="contained"
            sx={badgePrimaryButtonSx}
            onClick={onInputSugarNote}
            disabled={disabled}
            tabIndex={0}
            ref={sugarButtonRef}
          >
            Input Sugar Note
          </Button>
        </Box>
      )}

      {showCreditHold && (
        <FormControlLabel
          control={<Checkbox checked={creditHoldChecked} disabled />}
          label="Customer-Credit Hold"
        />
      )}

      {hasSheets && (
        <FormControlLabel
          control={
            <Checkbox
              checked={revReq}
              onChange={onToggleRevReq}
              disabled={disabled || Boolean(revReqLocked)}
            />
          }
          label="Revision Requested"
        />
      )}

      {showSubmit && (
        <Box>
          <Button
            size="small"
            variant="contained"
            sx={badgePrimaryButtonSx}
            onClick={onSubmit}
            disabled={disabled}
            tabIndex={0}
          >
            Submit
          </Button>
        </Box>
      )}
    </Stack>
  );
}
